import React from "react";
import dayjs from "dayjs"

import { capitalizeString } from "../../utils/capitalizeString";
import { Typography } from "@mui/material";


const PrintViewNetwork = ({ profileData, date }) => {


    return (


        <div className="printOnly" >

            <div  >
                <img className="width-100p" height="480px" src="https://beta.instantmudra.net/apps/beta/media/images/border.jpg" />

            </div>

            <div className="position-absolute top-60 left-50">

                <Typography variant="customh1" className="text-center" >Business Associate Certificate</Typography>
                <br />
                <Typography variant="printNetwork" >This is to certify that <strong>{profileData.outlet_name} - {profileData.full_name}</strong> is an authorized <strong>{capitalizeString(profileData.role_name)}</strong> of <br /> <strong>Instant Mudra Technologies Private Limited.</strong></Typography>
                <Typography variant="printNetwork">The <strong>{capitalizeString(profileData.role_name)}</strong> has been authorized to offer all<br />
                    digital services to their customers .</Typography>
                <br />
                <br />
                <Typography variant="printNetwork">This certificate is valid from <strong>{date}</strong> till <strong>{dayjs("2022/05/18").add(5, "year").format("DD/MM/YYYY")}</strong> </Typography>
                <Typography variant="printNetwork"><strong>PANCARD NO :{profileData.pan}</strong></Typography>
                <div className="flex justifyC-space-evenly">
                    <div className="alignS-center"> 
                        <Typography variant="customh4">Merchant ID <br />{profileData.guid}</Typography>
                    </div>


                    <img src="https://beta.instantmudra.net/apps/beta/media/logos/Instant-Mudra-Logo.png" width="170px" />

                    <div>

                        <img width="96px" height="auto" src="https://beta.instantmudra.net/apps/beta/media/images/sign4.png" /><br />
                        <Typography variant="customh4">
                            Mr. Sajjad Shaikh<br />
                            (Co-Founder &amp; CEO)
                        </Typography>

                    </div>
                </div>

            </div>

        </div>


    )
}

export default PrintViewNetwork